export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key))
      return false
  }
  return true
}

export function stringEmpty(string){
  if (string == undefined || string == null || string == "") {
    return ""
  }
  return string
}

export function pad(num) {
  var s = "00" + num;
  return s.substr(s.length - 2);
}

export function getShipbackPrice(quotes, mode) {
  var price = null
  quotes.forEach(function(quote) {
    if (quote.mode == mode) {
      price = quote.customer_price_cents
    }
  })
  return price
}

export function isStringEmpty(string) {
  return !trimString(string).length
}

export function trimString(string) {
  if (string == "" || string == undefined) {
    return string
  } else {
    return string.trim()
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/assets/utils.js